import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { Menu, Transition } from "@headlessui/react";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Fragment } from "react/jsx-runtime";
import useDownload from "../../customHooks/useDownload";
import DownloadIcon from "../../Icons/DownloadIcon";
import Modal from "../Reusable/Modal";
import usePostHook from "../../customHooks/usePostHook";
import { useState } from "react";
import EmailDownloadForm from "./EmailDownloadForm";
import APIS from "../../constant/EndPoint";

export default function ({ isDownload, queryKey }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { download } = useDownload({});
  const [isOpenEmailDownlaodPopup, setIsOpenEmailDownloadPopup] =
    useState(false);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["email-excel-download"],
  });

  const checkSelected = () => {
    const selectedItems = searchParams.get("selectedItems");
    if (!selectedItems || selectedItems.split(",").length === 0) {
      toast.error("Please select a order to continue");
      return { hasSelectedItems: false, selectedItems };
    }
    return { hasSelectedItems: true, selectedItems };
  };

  const handleDownloadExcel = async () => {
    const { hasSelectedItems, selectedItems } = checkSelected();
    if (!hasSelectedItems) return;
    try {
      await download(
        `/logisticservice/api/order/download-excel-logistic/`,
        `${queryKey}-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`,
        selectedItems
      );
    } catch (e) {
      console.error(e);
    }
  };
  const handleExcelDownloadonEmail = async (values: any, setError: any) => {
    const url = APIS.EXCELDOWNLOAD;
    const formData = {
      ...values,
      client_type: "logistic",
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setIsOpenEmailDownloadPopup(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleVCTSExcelDownload = async () => {
    const { hasSelectedItems, selectedItems } = checkSelected();
    if (!hasSelectedItems) return;
    try {
      await download(
        `/logisticservice/api/order/download-vcts-excel/`,
        `${queryKey}-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`,
        selectedItems
      );
    } catch (e) {
      console.error(e);
    }
  };

  return isDownload ? (
    <>
      <AccessControl allowedPermissions={["can_download"]}>
        <div className={tw`top-16 text-right`}>
          <Menu as="div" className={tw`relative inline-block text-left`}>
            <div>
              <Menu.Button
                className={tw`flex w-full min-w-48 gap-x-1 space-between items-center  rounded-md text-primary px-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
              >
                <div className={tw`h-[18px] w-[18px]`}>
                  <DownloadIcon color={"var(--primary)"} />
                </div>
                <p className={tw`flex items-center align-center`}>Download</p>
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter={tw`transition ease-out duration-100`}
              enterFrom={tw`transform opacity-0 scale-95`}
              enterTo={tw`transform opacity-100 scale-100`}
              leave={tw`transition ease-in duration-75`}
              leaveFrom={tw`transform opacity-100 scale-100`}
              leaveTo={tw`transform opacity-0 scale-95`}
            >
              <Menu.Items
                className={tw`absolute z-[100] mt-2 w-40 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none right-0`}
              >
                <div className={tw`px-1 py-1`}>
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={handleDownloadExcel}
                        className={tw`${
                          active ? "bg-primary text-white" : "text-gray-900"
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      >
                        Excel Download
                      </button>
                    )}
                  </Menu.Item>
                  <hr />
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() =>
                          setIsOpenEmailDownloadPopup(!isOpenEmailDownlaodPopup)
                        }
                        className={tw`${
                          active ? "bg-primary text-white" : "text-gray-900"
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      >
                        Email Download
                      </button>
                    )}
                  </Menu.Item>
                  <hr />
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={handleVCTSExcelDownload}
                        className={tw`${
                          active ? "bg-primary text-white" : "text-gray-900"
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                      >
                        VCTS Excel Download
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </AccessControl>
      <Modal
        isOpen={isOpenEmailDownlaodPopup}
        setIsOpen={setIsOpenEmailDownloadPopup}
      >
        <EmailDownloadForm
          handleDownload={handleExcelDownloadonEmail}
          isLoading={isPostLoading}
        />
      </Modal>
    </>
  ) : null;
}
